import { areMonthYearEqual, formatMonthYear, MonthYear } from '@common/neo.tax';
import { colors, Stack, Tooltip } from '@ui-components/neo.tax';
import { ReactComponent as WarningTriangle } from '@ui-components/neo.tax/dist/icons/warning-triangle.svg';

import { StyledLabel } from './asc-project-detail-form.styled';

export type AscProjectDetailCapitalizationEndDateLabelProps = {
  value: MonthYear | null;
  predictedValue: MonthYear | null;
  label: string;
};

export const AscProjectDetailCapitalizationEndDateLabel = ({
  label,
  predictedValue,
  value,
}: AscProjectDetailCapitalizationEndDateLabelProps): React.ReactElement => {
  const warning =
    predictedValue && (!value || !areMonthYearEqual(predictedValue, value)) ? (
      <Tooltip text={'Capitalization end date differs from prediction: ' + formatMonthYear(predictedValue)}>
        <WarningTriangle width={16} color={colors.lemon[400]} />
      </Tooltip>
    ) : null;

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <StyledLabel>{label}</StyledLabel>
      {warning}
    </Stack>
  );
};
